const OPEN = 'אור לוי, מנכ"ל קבוצת קומיוניטי';

const item = (time, title, sub = '') => ({ time, title, sub });

export const INVITATION_TEMPLATES = [
  {
    id: 'intro', name: 'כנס היכרות', title: 'כנס היכרות',
    tagline: 'הכירו את הפרויקט, את הצוות ואת התהליך שלפנינו', endTime: '20:40',
    agenda: [
      item('19:00', 'התכנסות וקבלת פנים', 'רישום משתתפים וכיבוד קל'),
      item('19:15', 'פתיחה וברכות', OPEN),
      item('19:25', 'הכירו את קבוצת קומיוניטי וצוות הפרויקט', 'מי אנחנו ומי ילווה אתכם לאורך הדרך'),
      item('19:40', 'מהו פינוי בינוי?', 'עיקרי התהליך ושלביו מתחילתו ועד האכלוס'),
      item('20:05', 'לוח זמנים צפוי', 'מה מצפה לכם בחודשים הקרובים'),
      item('20:15', 'שאלות ותשובות'),
      item('20:35', 'סיכום וצעדים הבאים'),
    ],
  },
  {
    id: 'representatives', name: 'כנס בחירת הנציגות', title: 'כנס בחירת הנציגות',
    tagline: 'בוחרים יחד את הנציגים שייצגו את כלל הדיירים', endTime: '20:35',
    agenda: [
      item('19:00', 'התכנסות ורישום משתתפים', 'אימות זכאות להצבעה'),
      item('19:15', 'פתיחה', OPEN),
      item('19:25', 'תפקיד הנציגות', 'סמכויות, חובות ואופן העבודה מול הדיירים'),
      item('19:40', 'הצגת המועמדים', 'כל מועמד מציג את עצמו'),
      item('20:00', 'הצבעה וספירת קולות'),
      item('20:20', 'הכרזה על הנציגות הנבחרת'),
      item('20:30', 'סיכום והמשך התהליך'),
    ],
  },
  {
    id: 'developer-lawyer', name: 'כנס בחירת יזם ועורך דין', title: 'כנס בחירת יזם ועורך דין מייצג',
    tagline: 'החלטה משותפת על היזם ועל עורך הדין שילוו את הפרויקט', endTime: '21:10',
    agenda: [
      item('19:00', 'התכנסות ורישום משתתפים'),
      item('19:15', 'פתיחה וסקירת התהליך עד כה', OPEN),
      item('19:25', 'הליך הבחירה והמלצת הנציגות', 'קריטריונים להשוואה בין ההצעות'),
      item('19:40', 'הצגת היזמים המתמודדים'),
      item('20:10', 'הצגת עורכי הדין המתמודדים'),
      item('20:30', 'שאלות ותשובות'),
      item('20:50', 'הצבעה והכרזה על התוצאות'),
      item('21:05', 'סיכום'),
    ],
  },
  {
    id: 'planning', name: 'כנס הצגת תכנון (תב"ע)', title: 'כנס הצגת תכנון (תב"ע)',
    tagline: 'כך ייראו הבניינים והשכונה החדשה', endTime: '21:05',
    agenda: [
      item('19:00', 'התכנסות וקבלת פנים'),
      item('19:15', 'פתיחה', OPEN),
      item('19:25', 'מעמד התב"ע והסטטוס התכנוני', 'היכן אנחנו בהליכי האישור'),
      item('19:40', 'הצגת התכנון', 'מבנים, שטחים, חזיתות וסביבה'),
      item('20:10', 'זכויות הבנייה והתמורות לדיירים'),
      item('20:30', 'לוח זמנים להליכי האישור'),
      item('20:40', 'שאלות ותשובות'),
      item('21:00', 'סיכום וצעדים הבאים'),
    ],
  },
  {
    id: 'signing', name: 'כנס חתימות על ההסכם המשפטי', title: 'כנס חתימות על ההסכם המשפטי',
    tagline: 'הצעד המשפטי המרכזי בדרך לדירה החדשה', endTime: '21:25',
    agenda: [
      item('19:00', 'התכנסות ורישום משתתפים', 'הצגת תעודת זהות'),
      item('19:15', 'פתיחה', OPEN),
      item('19:25', 'עיקרי ההסכם', 'סקירה על ידי עורך הדין המייצג'),
      item('19:55', 'תמורות, ערבויות ובטחונות'),
      item('20:15', 'שאלות ותשובות'),
      item('20:35', 'חתימה על ההסכם', 'בליווי עורכי הדין'),
      item('21:20', 'סיכום וצעדים הבאים'),
    ],
  },
  {
    id: 'evacuation', name: 'כנס לקראת פינוי והריסה', title: 'כנס לקראת פינוי והריסה',
    tagline: 'מתכוננים יחד ליציאה לדרך', endTime: '21:00',
    agenda: [
      item('19:00', 'התכנסות וקבלת פנים'),
      item('19:15', 'פתיחה', OPEN),
      item('19:25', 'לוח זמנים לפינוי ולהריסה'),
      item('19:40', 'הנחיות לפינוי', 'אריזה, מעבר וניתוק מתשתיות'),
      item('20:00', 'דיור חלופי ותשלומים', 'דמי שכירות ותנאים'),
      item('20:20', 'בטיחות באתר ובתקופת העבודות'),
      item('20:35', 'שאלות ותשובות'),
      item('20:55', 'סיכום'),
    ],
  },
  {
    id: 'keys', name: 'כנס מסירת מפתחות ואכלוס', title: 'כנס מסירת מפתחות ואכלוס',
    tagline: 'חוזרים הביתה', endTime: '20:55',
    agenda: [
      item('19:00', 'התכנסות וקבלת פנים'),
      item('19:15', 'פתיחה וברכות', OPEN),
      item('19:25', 'תהליך המסירה והאכלוס'),
      item('19:40', 'בדק בית ורשימת ליקויים', 'אחריות ותיקונים'),
      item('20:00', 'ועד הבית וניהול הבניין', 'חיבור לתשתיות והסדרי תחזוקה'),
      item('20:15', 'חלוקת המפתחות'),
      item('20:45', 'שאלות וסיכום'),
    ],
  },
  {
    id: 'apartments', name: 'כנס בחירת דירות', title: 'כנס בחירת דירות',
    tagline: 'כל דייר בוחר את דירתו החדשה', endTime: '21:25',
    agenda: [
      item('19:00', 'התכנסות ורישום משתתפים'),
      item('19:15', 'פתיחה', OPEN),
      item('19:25', 'מבנה הבניינים ומפות הדירות'),
      item('19:45', 'כללי הבחירה ושלביה', 'סדר הבחירה ואופן ההכרעה'),
      item('20:00', 'בחירת הדירות', 'לפי הסדר שנקבע'),
      item('21:00', 'אישור סופי וחתימה על טופס הבחירה'),
      item('21:20', 'סיכום'),
    ],
  },
  {
    id: 'update', name: 'כנס עדכון', title: 'כנס עדכון',
    tagline: 'מה התקדם, ומה הצעד הבא', endTime: '20:40',
    agenda: [
      item('19:00', 'התכנסות וקבלת פנים'),
      item('19:15', 'פתיחה', OPEN),
      item('19:25', 'עדכון על התקדמות הפרויקט'),
      item('19:45', 'אבני דרך שהושלמו והמשימות הבאות'),
      item('20:00', 'עדכוני הנציגות והיזם'),
      item('20:15', 'שאלות ותשובות'),
      item('20:35', 'סיכום'),
    ],
  },
];

export function shiftTime(hhmm, deltaMinutes) {
  const m = String(hhmm || '').match(/^(\d{1,2}):(\d{2})$/);
  if (!m) return hhmm;
  const total = (((+m[1] * 60 + +m[2] + deltaMinutes) % 1440) + 1440) % 1440;
  return `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`;
}

export function minutesOf(hhmm) {
  const m = String(hhmm || '').match(/^(\d{1,2}):(\d{2})$/);
  return m ? +m[1] * 60 + +m[2] : 0;
}
